<template>
  <TheModalRequest :class="'modal-request-holiday'">
    <ElementModal @close="closeModal">
      <h2 slot="header">{{ $t(`message.holidays.request.title`) }}</h2>
      <div slot="body">

        <div class="modal-request-holiday__info" v-if="error.start || error.end || errorMessage">
          <div v-if="error.start">Invalid or empty start date</div>
          <div v-if="error.end">Invalid or empty end date</div>
          <div v-if="errorMessage">{{ errorMessage }}</div>
        </div>

        <form id="holidayRequest" @submit.prevent="submitForm">

          <!-- Start Date -->
          <ElementFormGroup :label="$t(`message.modal.request.startDate`)">
            <div class="form-day">
              <datepicker placeholder="From" format="dd/MM/yyyy" v-model="start.date" @input="handleStartDate" />
              <div class="form-day__select">
                <select v-model="start.moment">
                  <option value="morning">{{ $t(`message.modal.request.morning`) }}</option>
                  <option value="afternoon">{{ $t(`message.modal.request.afternoon`) }}</option>
                </select>
              </div>
            </div>
            <!-- <ElementFormDay placeholder="From" selected-value="morning" @change="handleStartDate" /> -->
          </ElementFormGroup>

          <!-- End Date -->
          <ElementFormGroup :label="$t(`message.modal.request.endDate`)">
            <div class="form-day">
              <datepicker placeholder="End" format="dd/MM/yyyy" v-model="end.date" @input="handleEndDate" />
              <div class="form-day__select">
                <select v-model="end.moment">
                  <option value="morning">{{ $t(`message.modal.request.morning`) }}</option>
                  <option value="afternoon">{{ $t(`message.modal.request.afternoon`) }}</option>
                </select>
              </div>
            </div>
            <!-- <ElementFormDay placeholder="End" selected-value="afternoon" @change="handleEndDate" /> -->
          </ElementFormGroup>

          <!-- Comment -->
          <ElementFormGroup :label="$t(`message.modal.request.comment`)">
            <ElementFormTextarea @change="handleComment" />
          </ElementFormGroup>

          <!-- Button -->
          <div class="form-group">
            <BaseSubmit :disabled="!allowSubmit">{{ $t(`message.modal.request.submit`) }}</BaseSubmit>
            <span>{{ $t(`message.modal.request.or`) }}</span>
            <a href="javascript:void(0)" class="button-cancel" @click="cancelForm()">{{ $t(`message.modal.request.cancel`) }}</a>
          </div>

        </form>
      </div>
    </ElementModal>
  </TheModalRequest>
</template>

<script>
import { fetchPostService } from '@modules/api'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import BaseSubmit from '@base/BaseSubmit'
import ElementFormGroup from '@elements/ElementFormGroup'
// import ElementFormDay from '@elements/ElementFormDay'
import ElementFormTextarea from '@elements/ElementFormTextarea'
import ElementModal from '@elements/ElementModal'
import TheModalRequest from './TheModalRequest'

export default {
  name: 'TheModalHolidayRequest',
  components: {
    Datepicker,
    BaseSubmit,
    ElementModal,
    ElementFormGroup,
    // ElementFormDay,
    ElementFormTextarea,
    TheModalRequest
  },
  props: {
    submit: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      allowSubmit: false,
      error: {
        start: false,
        end: false
      },
      start: {
        date: '',
        moment: 'morning'
      },
      end: {
        date: '',
        moment: 'afternoon'
      },
      comment: '',
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters({
      name: 'modal/getName'
    }),
    showModal () {
      return this.name === 'holiday'
    }
  },
  watch: {
    start: {
      handler () {
        this.checkSubmitAvailability()
      },
      deep: true
    },
    end: {
      handler () {
        this.checkSubmitAvailability()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      updateName: 'modal/updateName',
      fetchGetPage: 'page/fetchGetPage'
    }),
    closeModal () {
      this.updateName('')
    },
    submitForm () {
      this.error.start = this.start.date === ''
      this.error.end = this.end.date === ''

      if (!this.error.start && !this.error.end) {
        fetchPostService('holidays-request', {
          start: {
            date: moment(this.start.date).format('DD/MM/YYYY'),
            moment: this.start.moment
          },
          end: {
            date: moment(this.end.date).format('DD/MM/YYYY'),
            moment: this.end.moment
          },
          comment: this.comment
        })
          .then(({ data }) => {
            this.errorMessage = ''
            if (data.error && !data.success) {
              this.errorMessage = data.error
            } else {
              this.fetchGetPage({ service: 'holidays' }).then(() => {
                this.closeModal()
              })
            }
          })
      }
    },
    cancelForm () {
      this.updateName('')
    },
    handleStartDate (date) {
      this.end.date = this.start.date
    },
    handleEndDate (date) {
      //
    },
    handleComment (string) {
      this.comment = string
    },
    checkSubmitAvailability () {
      this.allowSubmit = this.start.date !== '' && this.end.date !== ''
    }
  }
}
</script>

<style lang="scss">
.modal-request-holiday{

  &__info{
    @include form-info-error;
  }
}

.form-day{
  display: flex;
  justify-content: flex-start;
  align-items: stretch;

  > div{
    flex: 0 1 auto;
    width: 100%;

    &:not(:last-of-type){
      margin-right: layout("spacing");
    }
  }

  input, select{
    margin: 0;
  }

  &__select{
    @include custom-select;
  }

  .vdp-datepicker{
    @include icon(icons("events"));
    position: relative;

    &__calendar{
      width: 100%;

      .month{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &:before{
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
      color: colors('primary');
      display: block;
      // width: 2rem;
      // height: 2rem;
      font-size: 1.9rem;
    }
    div:first-child{
      height: 100%;
      input{
        height: 100%;
      }
    }
  }
}
</style>
